
import Vue from 'vue';

export default Vue.extend({
  props: {
    clipboardSnackbarVisible: {
      type: Boolean,
      default: false,
    },
    latestClipboardEntry: {
      type: String,
      default: '',
    },
    isClipboardCopySuccess: {
      type: Boolean,
      default: false,
    },
    latestClipboardTitle: {
      type: String,
      default: 'Copied to clipboard',
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      snackTimeout: 5000,
      visible: this.clipboardSnackbarVisible,
      timeoutID: null,
      messageTitle: this.latestClipboardTitle,
    };
  },
  computed: {
    successMessage() {
      const copySuccessMessage = this.isClipboardCopySuccess ? `${this.messageTitle}:&nbsp;` : ': ';

      return !!this.message ? this.message : `${copySuccessMessage}<a style="color: white" class="text-center" href="${this.latestClipboardEntry}" target="_blank"><u>${this.latestClipboardEntry}</u></a>`;
    },
  },
  watch: {
    latestClipboardTitle(val) {
      this.messageTitle = val;
    },
    clipboardSnackbarVisible(val) {
      this.visible = val;

      if (val) {
        // When the snackbar auto closed make sure reset visible data.
        clearTimeout(this.timeoutID as any)

        this.timeoutID = (setTimeout(() => {
          (this as any).onSnackbarClose();
        }, (this as any).snackTimeout) as any);
      }
    },
  },
  methods: {
    onSnackbarClose() {
      this.$emit('on-snackbar-close', false);
    },
  },
})
